<template>
  <modal :open="internalOpen">
    <template #header>
      <modal-header variant="cross" @cancel="internalOpen = false">
        <h1>{{ $t("pages.modal.resendConfirmation.title") }}</h1>
      </modal-header>
    </template>

    <div class="text-center mt-17.5">
      <h2 class="whitespace-nowrap">
        {{ $t("pages.modal.resendConfirmation.description") }}
      </h2>
      <span class="block mt-3">
        {{ $t("pages.modal.resendConfirmation.helpText") }}
      </span>
      <custom-button
        variant="primary"
        class="mt-15"
        :busy="loading"
        @click="resendConfirmation"
      >
        {{ $t("pages.modal.resendConfirmation.buttonText") }}
      </custom-button>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import Modal from '@utils/Modal/Modal.vue';
import { useNotify } from '@utils/notifications';
import { useFetchAction } from '@hooks/fetch';
import CustomButton from '@components/utils/CustomButton.vue';
import type { User } from '@/entities/Entities';

interface Props {
  open: boolean;
  user: User;
}

const emit = defineEmits(['update:open']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

const { t } = useI18n();

const notify = useNotify();

const [exec, { loading }] = useFetchAction();

const resendConfirmation = async () => {
  try {
    await exec('/users/resend-confirmation', {
      method: 'POST',
      body: {
        email: props.user.email,
      },
    });

    notify?.({
      variant: 'success',
      title: t('pages.modal.resetConfirmation.saveSuccess'),
    });

    internalOpen.value = false;
  } catch (e) {
    notify?.({
      variant: 'error',
      title: t('pages.modal.resetConfirmation.saveError'),
    });
  }
};
</script>

<style lang="scss" scoped></style>
